// TODO cover by unit tests
angular.module('gateApp').component('parallaxBackground', {
  bindings: {
    imageUrl: '<',
    aligment: '@',
    maxOffset: '@',
    gradient: '@',
  },
  controller: function (
    $element,
    $window: ng.IWindowService,
    $document: ng.IDocumentService,
  ) {
    const $ctrl = this;

    $ctrl.gradient = $ctrl.gradient || '0,0,0,.5';

    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        Method Declarations
        ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

    function $onInit() {
      $ctrl.updateBackground();
    }

    function $postLink() {
      $document.on('resize', $ctrl.updateBackground);
      $document.on('scroll', $ctrl.updateBackground);
      $document.on('touchmove', $ctrl.updateBackground);

      $ctrl.maxOffset = $ctrl.maxOffset || 40;
      $element.parent().css('position', 'relative');
      $element.parent().css('overflow', 'hidden');

      $element.css({
        height:
          $element.parent().prop('offsetHeight') + $ctrl.maxOffset * 2 + 'px',
        width: '100%',
        position: 'absolute',
        top: '0px',
        left: '0px',
        zIndex: 0,
        background: `linear-gradient(to bottom, rgba(${$ctrl.gradient}), rgba(${$ctrl.gradient})), url('${$ctrl.imageUrl}')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: ($ctrl.aligment || 'center') + ' center',
      });
    }

    function updateBackground() {
      const offset = $ctrl.getOffset($element.parent(), $ctrl.maxOffset);
      $element.css(
        '-webkit-transform',
        'translate3d(0px' + ', ' + offset + 'px, 0)',
      );
      $element.css('transform', 'translate3d(0px' + ', ' + offset + 'px, 0)');
    }

    function getOffset(element, maxOffset) {
      const rect = element[0].getBoundingClientRect();
      let offset = 0;
      if (rect) {
        const viewHeight = Math.max(
          $window.document.documentElement.clientHeight,
          $window.innerHeight,
        );
        if (rect.bottom >= 0) {
          offset = viewHeight - rect.bottom;
        }
      }

      return (
        ((offset * maxOffset) /
          (Math.max(
            $window.document.documentElement.clientHeight,
            $window.innerHeight,
          ) -
            0) -
          maxOffset) *
        2
      );
    }

    function $onDestroy() {
      $document.off('resize', $ctrl.updateBackground);
      $document.off('scroll', $ctrl.updateBackground);
      $document.off('touchmove', $ctrl.updateBackground);
    }

    $ctrl.$postLink = $postLink;
    $ctrl.$onInit = $onInit;
    $ctrl.$onDestroy = $onDestroy;
    $ctrl.updateBackground = updateBackground;
    $ctrl.getOffset = getOffset;
  },
});
